import React, {Fragment, useEffect, useState} from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import JobPaymentPopupTransaction from "./JobPaymentPopupTransaction";
import {getJobTransactions} from "./jobPaymentAsyncActions";

const JobPaymentPopupTransactions = (props) => {

  const {transactionsList, refundTransactionId, refundTransactionStatus, getJobTransactions} = props;

  const [loading, setLoading] = useState(true);

  const getTransactions = async () => {
    setLoading(true);
    await getJobTransactions();
    setLoading(false);
  }

  useEffect(() => {
    getTransactions();
  }, [])

  const getContent = () => {
    if (refundTransactionStatus === "success") {
      const transaction = transactionsList.find(transaction => transaction.transactionId === refundTransactionId);
      return (
        <Fragment>
          <div className="job-payment__status flex flex--center">
            <FormattedMessage id="paymentPopup.statuses.refundSuccess"/>
          </div>
          <div className="job-payment__order-id">
            <FormattedMessage id="paymentPopup.orderId"/>: {refundTransactionId}
          </div>
          <p className="job-payment__title color-charcoal">
            <FormattedMessage id="paymentPopup.refund.success.title"/>
          </p>
          <p className="job-payment__text job-payment__container color-charcoal">
            <FormattedMessage id="paymentPopup.refund.success.text" values={{
              amount: transaction.amount,
            }}/>
            <br/>
            <FormattedMessage id="paymentPopup.refund.success.text2"/>
          </p>
        </Fragment>
      )
    }
    if (refundTransactionId) {
      const transaction = transactionsList.find(transaction => transaction.transactionId === refundTransactionId);
      return (
        <Fragment>
          <div className="job-payment__order-id">
            <FormattedMessage id="paymentPopup.orderId"/>: {refundTransactionId}
          </div>
          <p className="job-payment__title color-charcoal">
            <FormattedMessage id="paymentPopup.refund.title"/>
          </p>
          <p className="job-payment__text job-payment__container color-charcoal">
            <FormattedMessage id="paymentPopup.refund.text" values={{
              amount: transaction.amount,
            }}/>
            <br/>
            <FormattedMessage id="paymentPopup.refund.text2"/>
          </p>
        </Fragment>
      )
    }
    if (loading) {
      return <div className="ui-loader ui-loader--medium"/>
    }
    if (transactionsList.length) {
      return (
        <ul className="fix-ul">
          <li className="job-payment__transaction job-payment__transaction--head flex color-gray4 text-uppercase
           flex--center bold margin-b8">
            <div className="job-payment__transaction-cell job-payment__transaction-cell--time">
              Date
            </div>
            <div className="job-payment__transaction-cell job-payment__transaction-cell--amount">
              Amount
            </div>
            <div className="job-payment__transaction-cell job-payment__transaction-cell--type">
              Type
            </div>
            <div className="job-payment__transaction-cell job-payment__transaction-cell--status">
              Status
            </div>
            <div className="job-payment__transaction-cell job-payment__transaction-cell--button">
              <FormattedMessage id="paymentPopup.refund.button"/>
            </div>
          </li>
          {transactionsList.map(transaction => (
            <JobPaymentPopupTransaction key={transaction.transactionId}
                                        transaction={transaction}/>
          ))}
        </ul>
      )
    }
    return (
      <p className="job-payment__title color-charcoal">
        <FormattedMessage id="paymentPopup.noTransactions"/>
      </p>
    )
  }

  const isScrollable = (transactionsList.length > 6) && !refundTransactionId;

  return (
    <div className={"flex flex--column relative job-payment__content relative"
      + (transactionsList.length && !refundTransactionId ? " padding-t0" : " job-payment__container")
      + (isScrollable ? " scrollbar3 mr-05 pr-05" : "")
      + (!transactionsList.length || refundTransactionId ? " flex--center" : "")}>
      {getContent()}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {refundTransactionId, refundTransactionStatus, transactionsList} = store.jobPaymentState;

  return {
    refundTransactionId,
    refundTransactionStatus,
    transactionsList,
  };
};

const mapDispatchToProps = {
  getJobTransactions,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(JobPaymentPopupTransactions)
)
